<template>
    <div class="container px-8 mx-auto md:w-96 w-96">
      <Card class="">
        <form action="" class="w-full bg-gray-600 px-4 py-4" @submit.prevent="updateMode ? UpdateMenu() : AddMenu()" >
          <label class="block text-sm mb-1 ">عنوان</label>
          <Input class="w-52" placeholder="عنوان" v-model="menu.Name"
                 :error="error.Name" @keydown="error.Name = ''" />
  
         
  
          <!--<div class="rounded-xl overflow-hidden mt-4">
            <div id="map" class="h-64 z-0"></div> change rahim
          </div>-->
         <!--<div class="fixed top-16 w-72">
          <Listbox v-model="selectedMainMenu">
      <div class="relative mt-1">
        <ListboxButton
          class="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm"
        >
          <span class="block truncate">{{ selectedMainMenu.name }}</span>
          <span
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
          >
          </span>
        </ListboxButton>

        <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <ListboxOptions
            class="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
          >
            <ListboxOption
              v-slot="{ active, selected }"
              v-for="mainmenu in this.MainmenuList"
              :key="mainmenu.name"
              :value="mainmenu"
              as="template"
            >
              <li
                :class="[
                  active ? 'bg-amber-100 text-amber-900' : 'text-gray-900',
                  'relative cursor-default select-none py-2 pl-10 pr-4',
                ]"
              >
                <span
                  :class="[
                    selected ? 'font-medium' : 'font-normal',
                    'block truncate',
                  ]"
                  >{{ mainmenu.name }}</span
                >
              </li>
            </ListboxOption>
          </ListboxOptions>
        </transition>
      </div>
    </Listbox>
         </div>-->
    <label class="block text-sm mb-1 mt-4">منوی اصلی</label>
    <select class="w-52 rounded-xl p-2 bg-white text-black" v-model="selectedMainMenu">
       <!--<option value="" class="" disabled>انتخاب منوی اصلی</option>-->
       <option v-for="mainmenu in this.MainmenuList"
               :key="mainmenu.id"
               :value="mainmenu.id"
               class="text-black">{{ mainmenu.name }}
        </option>
    </select>
    <label class="block text-sm mb-1 mt-4">نوع زبان</label>
    <select class="w-52 rounded-xl p-2 bg-white text-black " v-model="selectedLanguage" required>
       <!--<option value="" class="" disabled>انتخاب منوی اصلی</option>-->
       <option v-for="lang in this.Languages"
               :key="lang.id"
               :value="lang.id"
               class="text-black">{{ lang.name }}
        </option>
    </select>
    <label class="block text-sm mb-1 ">نوع ارز</label>
          <Input class="w-52" placeholder="نوع ارز" v-model="menu.currency"
                 :error="error.currency" @keydown="error.currency = ''" />
    <div class="flex mt-4 ">
            <label for="default" class="block text-sm ">فعال </label>
            <input id="default" type="checkbox" v-model="menu.isActive" >
    </div>
          <Button class="w-32 mt-4 mr-16  bg-blue-500 ">ثبت</Button>
        </form>
      </Card>
    </div>
  </template>
  
  <script>
  import Card from "@/components/General/VCard";
  import Input from "@/components/General/VInput";
  import Button from "@/components/General/VButton";

  import {CreateMenu, getMenu,getMainMenu, UpdateMenu} from "@/API/API.js";
  import {
     //Listbox,
     //ListboxLabel,
     //ListboxButton,
     //ListboxOptions,
     //ListboxOption,
  } from '@headlessui/vue'
import { GetLanguages } from "../API/API";
const toast = useToast()
import { useToast } from 'vue-toastification'
  //import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/20/solid'
  export default {
    name: "AddMenu",
    components: {Card, Input, Button,/*Listbox,ListboxButton,ListboxOptions,ListboxOption*/},
    data() {
      return {
         people :[
  { name: 'Wade Cooper' },
  { name: 'Arlene Mccoy' },
  { name: 'Devon Webb' },
  { name: 'Tom Cook' },
  { name: 'Tanya Fox' },
  { name: 'Hellen Schmidt' },
],
        selectedMainMenu:0 ,
        selectedLanguage:0,
        MainmenuList: [],
        Languages:[],
        updateMode: false,
        menu: {
          Id:0,
          Name: '',
          isActive: false,
          LanguageId:1,
          //mainMenuId:0
          mainScreenId:0,
          currency:''
        },
        error: {
          Name: '',
        }
      }
    },
    async created() {
      //this.menu.mainMenuId=this.selectedMainMenu
      //console.log(this.selectedMainMenu)
      let id = this.$route.params.id
      let tempmainmenu= (await getMainMenu()).data
      //let tempmainmenu= (await getMainMenu()).data.result
      let templanguages=(await GetLanguages()).data
      //let templanguages=(await GetLanguages()).data.result
      //console.log(templanguages)     
      //console.log(tempmainmenu)
      this.MainmenuList=JSON.parse(JSON.stringify(tempmainmenu))
      this.Languages=JSON.parse(JSON.stringify(templanguages))
       //this.MainmenuList=tempmainmenu
      //console.log(this.selectedMainMenu)
      if (id) {
        this.updateMode = true;
        this.$Progress.start()
        //let tmpmenu = JSON.parse(JSON.stringify((await getMenu(id)).data.result))
        let tmpmenu = JSON.parse(JSON.stringify((await getMenu(id)).data))
        let tmplanguage=JSON.parse(JSON.stringify((await GetLanguages()).data))
        //let tmplanguage=JSON.parse(JSON.stringify((await GetLanguages()).data.result))
        console.log(tmplanguage)
        //console.log(tmplanguage)
        this.$Progress.finish()
        //console.log(tmpmenu)
        //console.log(tmpmenu.name)
        //console.log(tmpmenu.isActive)
        console.log(888)
        console.log(tmpmenu)
        this.menu.Name=tmpmenu.name;
        this.menu.isActive=tmpmenu.isActive;
        this.menu.Id=tmpmenu.id;
        this.menu.currency=tmpmenu.currency;
        //console.log(this.menu)
        if(tmpmenu.mainScreenId>0){
          
          console.log(tmpmenu)
          this.selectedMainMenu=tmpmenu.mainScreenId;
          //this.selectedMainMenu=JSON.parse(JSON.stringify(this.selectedMainMenu))
          //let tt = (await getMenu(this.selectedMainMenu.Id)).data.result;
          //this.selectedMainMenu.name=tt.name;
          //this.selectedMainMenu=JSON.parse(JSON.stringify(this.selectedMainMenu))
          //console.log(this.selectedMainMenu)
          console.log(this.selectedMainMenu)
          console.log(tmpmenu.language.id)
        }
        if(tmpmenu.language.id>0){
          this.selectedLanguage=tmpmenu.language.id;
          console.log(this.selectedLanguage)
        }
           
      }      
    },
    methods: {
      AddMenu() {
        if (this.validatemenu()) {
          this.$Progress.start()
          //CreateMenu('rmmahryar',this.menu)
          this.menu.mainScreenId=this.selectedMainMenu
          this.menu.LanguageId=this.selectedLanguage
          console.log(this.menu);
          CreateMenu(this.$store.getters.slug,this.menu)
              .then(() => {
                this.$Progress.finish()
                
                if (this.$route.query.redirect) {
                  this.$router.push(this.$route.query.redirect)
                } else {
                  this.$router.push('/menulist')
                }
              })
              .catch((e) =>{ 
                        //console.log(7777)
                        //console.log(e.response.data)
                        toast.error(e.response.data.Message)
                        //toast.error("شماره موبایل یا رمز اشتباه است")
                        //reject()
                    })
        }
      
      },
      UpdateMenu() {
        if (this.validatemenu()) {
          this.$Progress.start()
          this.menu.mainScreenId=this.selectedMainMenu
          this.menu.LanguageId=this.selectedLanguage
          UpdateMenu(this.$store.getters.slug, this.menu)
              .then(() => {
                this.$Progress.finish()
                this.$router.push('/menulist')
              })
        }
      },
      validatemenu() {
        let result = true
        if (!this.menu.Name) {
          this.error.storeName = 'لطفا عنوان را وارد نمایید.'
          result = false
        }
        return result
      }
    }
  }
  </script>
  
